import { LicensedPartners as LicensedPartnersContent } from 'LicensedPartners';

const LicensedParters = () => {
  return <LicensedPartnersContent />;
};

export default LicensedParters;
